import React from "react";
import {
  FaUsers,
  FaInfoCircle,
  FaShieldAlt,
  FaCheckCircle,
  FaHeadset,
} from "react-icons/fa";
import "./Global_Opportunities.css";
import Common_Button from "../Common_Components/common_button/Common_Button";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const Global_Opportunities = () => {
  const navigate = useNavigate();

  const handleApplyNow = () => {
    navigate("/new/apply_now");
  };

  return (
    <section className="global-opportunities">
      <div className="hero-overlay"></div>

      <div className="hero-content">
        <h1 className="hero-title">
          Your Gateway to Global
          <span> Opportunities</span>
        </h1>

        <p className="hero-description">
          Connect skilled Indian professionals with trusted international
          <br className="desktop-break" />
          employers. We specialize in overseas recruitment across Middle East,
          <br className="desktop-break" />
          Europe, Asia & Gulf regions.
        </p>

        <div className="hero-buttons">
          <Common_Button
            type="button"
            text="Apply Now"
            icon={faUserPlus}
            className="application_submit_btn"
            onClick={handleApplyNow}
          />
          <button
            className="why-btn"
            onClick={() => navigate("/new/why_us")}
          >
            <FaInfoCircle />
            <span>Why Us</span>
          </button>
        </div>

        <div className="trust-items">
          <div className="trust-card">
            <FaShieldAlt />
            <span>MEA Registered</span>
          </div>

          <div className="trust-card">
            <FaCheckCircle />
            <span>100% Legal</span>
          </div>

          <div className="trust-card">
            <FaHeadset />
            <span>24/7 Support</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Global_Opportunities;
